import { NextPage } from "next";
import React, { useCallback, useEffect, useState } from "react";

import PageHead from "~/components/common/PageHead";
import MobilePage from "~/components/database/page/index/MobilePage";
import PcPage from "~/components/database/page/index/PcPage";
import { Props } from "~/components/database/page/index/lib";
import useIsSpMode from "~/lib/client/hooks/useIsSpMode";
import { Layout } from "~/lib/client/layout";
import { useActivityLogger } from "~/lib/client/logger/useActivityLogger";
import { createGraphqlClient } from "~/lib/graphql/graphqlClient";

const Page: NextPage<Props> = () => {
  const isSpMode = useIsSpMode();
  const pageName = "databaseIndex";
  const sendActivityLog = useActivityLogger();
  const [forms, setForms] = useState<Props["forms"] | undefined>();
  const pageHeadProps = {
    title: "データベース【FUSSY】みんなで作るデータベース",
    ogUrl: `/database`,
    ogDescription: "100以上のFaveと1000以上のデータを公開中！",
  };

  const fetchDatabaseContent = useCallback(async () => {
    const graphqlClient = createGraphqlClient();
    const { forms } = await graphqlClient.databaseContent();
    setForms(forms);
  }, []);

  const Page = isSpMode ? MobilePage : PcPage;

  useEffect(() => {
    if (sendActivityLog === undefined) return;

    (async () => {
      await sendActivityLog({
        pageName,
        actionName: "show",
      });
    })();
  }, [sendActivityLog]);

  useEffect(() => {
    (async () => await fetchDatabaseContent())();
    return;
  }, [fetchDatabaseContent]);

  return (
    <>
      <PageHead {...pageHeadProps} />
      <Layout layoutType={"YTLayout"}>{forms && <Page forms={forms} />}</Layout>
    </>
  );
};

export default Page;
